<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800" max-height="90vh">
      <v-card class="modal-fixed-layout">
        <v-card-title class="modal-header elevation-10 flex-shrink-0">
          <v-row>
            <v-col>
              <slot name="title">Avaliar Relatório Administrativo</slot>
            </v-col>
            <v-col class="text-right">
              <v-icon @click="closeReport" color="white"
                >mdi-window-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="modal-content-scrollable">
          <v-row>
            <v-col>
              <label class="v-label">Título do Relatório</label>
              <div class="report-title">{{ report.titulo }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="contract-section">
                <label class="v-label">Número do Contrato</label>
                <div class="contract-info">
                  <span class="contract-number">{{
                    report.contrato?.numContrato || "N/A"
                  }}</span>
                  <v-tooltip bottom max-width="400">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="ml-2"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div class="contract-tooltip">
                      <div>
                        <strong>Número:</strong>
                        {{ report.contrato?.numContrato || "N/A" }}
                      </div>
                      <div>
                        <strong>Natureza:</strong>
                        {{ report.contrato?.natureza || "N/A" }}
                      </div>
                      <div>
                        <strong>Vigência:</strong>
                        {{
                          formatDateRange(
                            report.contrato?.inicio,
                            report.contrato?.fim
                          )
                        }}
                      </div>
                      <div>
                        <strong>Horas Previstas:</strong>
                        {{ report.contrato?.qtdHorasPrevistas || "N/A" }}
                      </div>
                      <div>
                        <strong>Valor/Hora:</strong>
                        {{ formatCurrency(report.contrato?.valorHora) }}
                      </div>
                      <div v-if="report.contrato?.qtdEntregasPrevistas">
                        <strong>Entregas Previstas:</strong>
                        {{ report.contrato.qtdEntregasPrevistas }}
                      </div>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </v-col>
            <v-col>
              <div class="contract-section">
                <label class="v-label">Objeto do Contrato</label>
                <div class="report-title">
                  <v-tooltip
                    bottom
                    max-width="600"
                    v-if="
                      report.contrato?.descricao &&
                      report.contrato.descricao.length > 100
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="contract-description-truncated"
                      >
                        {{ truncateText(report.contrato.descricao, 100) }}...
                      </span>
                    </template>
                    <div class="contract-description-full">
                      {{ report.contrato.descricao }}
                    </div>
                  </v-tooltip>
                  <span v-else>
                    {{ report.contrato?.descricao || "N/A" }}
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="report.municipio.nome"
                disabled
                label="Município"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="report.horas"
                label="Horas Correspondentes"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                v-model="report.inicioString"
                v-mask="'##/##/#### ##:##'"
                label="Data de Início"
                placeholder="00/00/0000 00:00"
                disabled
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                v-model="report.fimString"
                v-mask="'##/##/#### ##:##'"
                label="Data de Término"
                placeholder="00/00/0000 00:00"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-tabs vertical>
              <v-tab>
                <v-icon left>mdi-file-chart</v-icon>
                Relatório
              </v-tab>

              <v-tab>
                <v-icon left>mdi-attachment</v-icon>
                Anexos
              </v-tab>

              <v-tab-item>
                <v-col>
                  <v-textarea v-model="report.descricao" readonly></v-textarea>
                  <div
                    v-if="canViewFullScreenReport"
                    class="full-screen-report-action"
                  >
                    <v-btn
                      small
                      outlined
                      color="primary"
                      @click="openFullScreen"
                    >
                      Ver em tela inteira
                    </v-btn>
                  </div>
                </v-col>
              </v-tab-item>

              <v-tab-item>
                <v-data-table
                  :headers="headersAnexos"
                  :items="report.anexos"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.download="{ item }">
                    <v-btn
                      outlined
                      color="primary"
                      class="ml-3"
                      @click="downloadAnexo(item)"
                    >
                      <span>Download</span>
                    </v-btn>
                  </template>

                  <template slot="no-data">
                    <span> Nenhum anexo retornado </span>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Motivo da rejeição"
                v-model="report.motivoRejeicao"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="modal-footer modal-footer-fixed flex-shrink-0">
          <v-row
            v-if="
              report.statusRelatorioId === 2 || report.statusRelatorioId === 3
            "
          >
            <v-col>
              <v-alert
                :type="report.statusRelatorioId === 2 ? 'success' : 'error'"
                outlined
                dense
                class="analysis-alert ma-0"
                :icon="
                  report.statusRelatorioId === 2
                    ? 'mdi-check-circle-outline'
                    : 'mdi-close-circle-outline'
                "
              >
                <div class="analysis-message">
                  <strong>
                    {{
                      report.statusRelatorioId === 2
                        ? "Relatório Aprovado"
                        : "Relatório Reprovado"
                    }}
                  </strong>
                  <div class="analysis-details">
                    <span v-if="report.usuarioAnaliseNavigation?.nome">
                      Analisado por:
                    </span>
                    <div v-if="report.dataAnalise">
                      {{ report.usuarioAnaliseNavigation.nome }}
                      <div>{{ formatDateTime(report.dataAnalise) }}</div>
                    </div>
                  </div>
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <!-- Mensagem de Pagamento -->
          <div
            v-if="report.statusRelatorioId === 4"
            class="payment-status-footer"
          >
            <v-alert
              type="success"
              outlined
              dense
              class="payment-alert-footer ma-0"
              icon="mdi-cash-check"
            >
              <div class="payment-message-footer">
                <strong>Inserido no processo de pagamento</strong>
                <span
                  v-if="getPaymentNumbers().length > 0"
                  class="payment-numbers"
                >
                  Número: {{ getPaymentNumbers().join(", ") }}
                </span>
              </div>
            </v-alert>
          </div>

          <!-- Spacer -->
          <div class="flex-grow-1"></div>

          <!-- Botões de Ação -->
          <div class="action-buttons">
            <v-btn color="error" outlined text @click="closeReport">
              Fechar
            </v-btn>
            <v-btn
              color="info"
              outlined
              text
              @click="save(2)"
              v-if="
                (isFullAdmin ||
                  (config.podeAnalisarRelatorioAdmin &&
                    groupsConfig.podeAnalisarRelatorioAdmin)) &&
                report.statusRelatorioId !== 4
              "
              class="ml-2"
            >
              Aprovar
            </v-btn>
            <v-btn
              color="info"
              outlined
              text
              @click="save(3)"
              v-if="
                (isFullAdmin ||
                  (config.podeAnalisarRelatorioAdmin &&
                    groupsConfig.podeAnalisarRelatorioAdmin)) &&
                report.statusRelatorioId !== 4
              "
              class="ml-2"
            >
              Rejeitar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fullScreenDialog" fullscreen>
      <v-card class="full-screen-report-card">
        <v-card-title class="full-screen-report-header">
          <span>Relatório em tela inteira</span>
          <v-spacer></v-spacer>
          <v-btn icon x-large @click="closeFullScreen" aria-label="Fechar">
            <v-icon size="38">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="full-screen-report-content">
          <div class="full-screen-report-text">{{ report.descricao }}</div>
        </v-card-text>

        <v-card-actions class="full-screen-report-footer">
          <v-spacer></v-spacer>
          <v-btn large outlined color="primary" @click="closeFullScreen">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalAnalyseReport",
  props: {
    dialog: { type: Boolean, default: false },
    id: { type: Number, required: false },
  },
  computed: {
    ...mapGetters(["isAdmin", "isFullAdmin"]),
    canViewFullScreenReport() {
      return (
        this.config?.verRelatorioTelaInteira &&
        this.groupsConfig?.verRelatorioTelaInteira
      );
    },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      fullScreenDialog: false,
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      report: {
        arquivos: [],
        municipio: {},
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    openFullScreen() {
      this.fullScreenDialog = true;
    },
    closeFullScreen() {
      this.fullScreenDialog = false;
    },
    closeReport() {
      this.closeFullScreen();
      this.$emit("onCloseReport");
    },
    formatDateTime(date) {
      if (!date) return "N/A";
      const dateObj = new Date(date);
      return `${dateObj.toLocaleDateString("pt-BR")}`;
    },
    save(statusId) {
      if (statusId === 3 && !this.report.motivoRejeicao) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.report.statusRelatorioId = statusId;
        delete this.report.anexos;

        administrativeReportAPI
          .analyse(this.report)
          .then((resp) => {
            this.setLoading(false);
            this.closeFullScreen();
            this.closeReport();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              "Erro ao atualizar relatório administrativo"
            );
          });
      }
    },
    get() {
      this.setLoading(true);
      administrativeReportAPI
        .get(this.id)
        .then((resp) => {
          this.report = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório administrativo");
        });
    },
    downloadAnexo(evidencia) {
      administrativeReportAPI
        .downloadAnexo(evidencia.relatorioAdministrativoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    formatCurrency(value) {
      if (!value) return "N/A";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleDateString("pt-BR");
    },
    formatDateRange(startDate, endDate) {
      const start = this.formatDate(startDate);
      const end = this.formatDate(endDate);
      if (start === "N/A" || end === "N/A") return "N/A";
      return `${start} - ${end}`;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) : text;
    },
    getPaymentNumbers() {
      if (
        !this.report.relatorioAdministrativoPagamentos ||
        !Array.isArray(this.report.relatorioAdministrativoPagamentos)
      ) {
        return [];
      }
      return this.report.relatorioAdministrativoPagamentos
        .map((pagamento) => {
          // Tentando acessar diferentes possíveis campos de número
          return pagamento.relatorioGestaoPagamentoId || "N/A";
        })
        .filter((numero) => numero !== "N/A");
    },
  },

  watch: {
    id: function () {
      this.get();
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
